import { useCallback, useState } from "react";

import { Box, ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import BallotIcon from '@mui/icons-material/Ballot';

import { ModalCustom } from "../../../components/ModalCustom";
import { SearchSingle } from "../../../components/Search";
import { ButtonConfirmCustom } from "../../../components/ButtonCustom";
import VariablesGrid from "../VariablesGrid";

export default function ModalVariables(props) {
  const {configModal, configVariablesGrid} = props

  const [openModal, setOpenModal] = useState(false)
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchTermChange = useCallback((value) => setSearchTerm(value), []);

  const renderModalVariables = () => {
    const allVariables = configVariablesGrid?.variables || {};

    let filteredResults = {};
    // Filtra l'oggetto in base a searchTerm
    if (searchTerm.trim() !== "") {
      Object.keys(allVariables).forEach(key => {
        const variable = allVariables[key];
        const searchText = searchTerm.toLowerCase();
        const variableName = variable.name.toLowerCase();
        // Se la variabile contiene il termine di ricerca, aggiungila ai risultati filtrati
        if (variableName.includes(searchText)) {
          filteredResults[key] = variable;
        }
      });
    } else {
      // Se non c'è un termine di ricerca, mostra tutte le variabili
      filteredResults = allVariables;
    }
    const renderButton = {
      Component:ButtonConfirmCustom,
      func:{
        onClickConfirm:() => {setOpenModal(false); configModal.search(); setSearchTerm("")},
        onClickCancel:() => {setOpenModal(false); setSearchTerm("")},
      }
    }
    
    return (
      <ModalCustom  {...configModal} 
                    onClose={() => setOpenModal(false)} 
                    open={openModal}
                    renderButton={<renderButton.Component {...renderButton.func}/>}>
        <VariablesGrid {...configVariablesGrid} variablesFiltered={filteredResults}/>
        <Box paddingTop={1} width={"100%"}>
          <SearchSingle onChange={handleSearchTermChange} className="variables-search"/>
        </Box>
      </ModalCustom>  
    )
  }

  return (
    <>
      <ToggleButtonGroup onChange={() => setOpenModal(true)}>
        <ToggleButton value="center" className="variables-table">
          <Tooltip title="Variabili">
            <BallotIcon />
          </Tooltip>
        </ToggleButton>
      </ToggleButtonGroup>
      {openModal && renderModalVariables()}
    </>
  )
}
